import React from 'react';
import { Checkbox, ICheckboxProps } from '../../../../../../ui';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { useDetailsFormContext } from '../hooks/useDetailsFormContext';

export const NewUserAccountCheckbox = (props: Partial<ICheckboxProps>) => {
	const { t } = useTranslation();
	const { register } = useDetailsFormContext();

	return (
		<Checkbox
			label={t('web_parking_details_form_sign_up_label')}
			{...props}
			{...register('shouldCreateNewUserAccount')}
		/>
	);
};
